const locale = "hu-HU";
const translations = {
	timeFormat: "HH:mm",
	dateFormat: "YYYY.MM.DD.",
	dateTimeFormat: "YYYY.MM.DD. HH:mm",
	"serviceReports.headline": "Szervizjelentések",
	"serviceReports.sublineMachine": "Tekintse meg a gépéhez tartozó szervizjelentéseket, és töltse le azokat.",
	"serviceReports.technicianName": "Szerviztechnikus neve",
	"serviceReports.machineNameAndNumber": "Gép és gépek sz.",
	"serviceReports.startDate": "Ettől",
	"serviceReports.endDate": "Eddig",
	"serviceReports.creationDate": "Létrehozási dátum",
	"serviceReports.openReport": "Szervizjelentés megnyitása (PDF)",
	"serviceReports.filter": "Szűrő",
	"serviceReports.missionNumber": "Beavatkozás száma",
	"serviceReports.assignmentType": "Szervizjelentés típusa",
	"serviceReports.reportTypes.IA": "Eltávolítási / áthelyezési jelentés",
	"serviceReports.reportTypes.AC": "Alkalmazási tanácsadási jelentés",
	"serviceReports.reportTypes.IV": "Telepítési előkészítési jelentés",
	"serviceReports.reportTypes.BA": "Értékelési jelentés",
	"serviceReports.reportTypes.UV": "Biztonsági felügyeleti jelentés",
	"serviceReports.reportTypes.IG": "Használt gép telepítési jelentése",
	"serviceReports.reportTypes.UB": "Minőség mérési jelentés",
	"serviceReports.reportTypes.PN": "Gyártási asszisztens jelentés",
	"serviceReports.reportTypes.NR": "Utólagos telepítési jelentés",
	"serviceReports.reportTypes.IB": "Telepítés / startup-jelentés",
	"serviceReports.reportTypes.II": "Telepítési integrációs jelentés",
	"serviceReports.reportTypes.IC": "Belső javítási jelentés",
	"serviceReports.reportTypes.MB": "\"Trade fair\" szerviz jelentés",
	"serviceReports.reportTypes.HW": "Forrás jelentés",
	"serviceReports.reportTypes.TT": "Technikus képzési jelentés",
	"serviceReports.reportTypes.SK": "Ügyfél oktatási jelentés",
	"serviceReports.reportTypes.RP": "Javítási jelentés",
	"serviceReports.reportTypes.RW": "Javítási és karbantartási jelentés",
	"serviceReports.reportTypes.WA": "Karbantartási jelentés",
	"serviceReports.reportTypesPlural.IA": "Eltávolítási / áthelyezési jelentések",
	"serviceReports.reportTypesPlural.AC": "Alkalmazási tanácsadási jelentések",
	"serviceReports.reportTypesPlural.IV": "Telepítési előkészítési jelentések",
	"serviceReports.reportTypesPlural.BA": "Értékelési jelentések",
	"serviceReports.reportTypesPlural.UV": "Biztonsági felügyeleti jelentések",
	"serviceReports.reportTypesPlural.IG": "Használt gép telepítési jelentések",
	"serviceReports.reportTypesPlural.UB": "Minőség mérési jelentések",
	"serviceReports.reportTypesPlural.PN": "Gyártási asszisztens jelentések",
	"serviceReports.reportTypesPlural.NR": "Utólagos telepítési jelentések",
	"serviceReports.reportTypesPlural.IB": "Telepítés / startup-jelentések",
	"serviceReports.reportTypesPlural.II": "Telepítési integrációs jelentések",
	"serviceReports.reportTypesPlural.IC": "Belső javítási jelentések",
	"serviceReports.reportTypesPlural.MB": "\"Trade fair\" szerviz jelentések",
	"serviceReports.reportTypesPlural.HW": "Forrás jelentések",
	"serviceReports.reportTypesPlural.TT": "Technikus képzési jelentések",
	"serviceReports.reportTypesPlural.SK": "Ügyfél oktatási jelentések",
	"serviceReports.reportTypesPlural.RP": "Javítási jelentések",
	"serviceReports.reportTypesPlural.RW": "Javítási és karbantartási jelentések",
	"serviceReports.reportTypesPlural.WA": "Karbantartási jelentések",
	"serviceReports.loadMore": "Még több betöltése",
	"serviceReports.loadError": "Hiba történt az adatok betöltésénél",
	"serviceReports.noReportsFound": "Jelenleg nem állnak rendelkezésre szervizjelentések.",
	"serviceReports.noReportsAvailable": "Jelenleg nem állnak rendelkezésre szervizjelentések.",
	missingAuthorization: "Hiányzó jogosultság",
	"headline.createCase": "Új szervizeset létrehozása",
	"headline.caseDetails": "Eset részletei",
	"headline.contactData": "Kapcsolati adatok",
	"field.reason.label": "Bejelentés oka",
	"field.machine.label": "Gép és gépek sz.",
	"field.softwareProblemClassification.label": "A probléma besorolása",
	"field.softwareInstallationProblem.label": "Telepítési probléma",
	"field.softwareLicenseIssue.label": "Licencprobléma",
	"field.softwareType.label": "Szoftver típusa",
	"field.softwareModule.label": "Szoftvermodul",
	"field.errorNumber.label": "Hibaszámok",
	"field.errorNumber.explanation": "pl. 0000FC00, 1.10.58102409 vagy 6000",
	"field.errorNumber.addAnotherNumber": "további hibaszámok megadása",
	"field.errorNumber.errorMessage": "Érvénytelen hibaszám",
	"field.message.label": "Üzenet",
	"field.message.placeholder": "Kérjük, írja le (üdvözlés nélkül) a lehető legkonkrétabban és a szükséges részletességgel kívánságát/problémáját. Nagyon köszönjük.",
	"field.fileUpload.label": "Mellékletek",
	"field.fileUpload.info": "Megengedett fájlformátumok: IMG, JPG, PNG, PDF, HTML, TruTops fájlok stb. (max. 16 MB) és MP4 videofájlok (max. 50 MB)",
	"field.salutation.label": "Megszólítás",
	"field.salutation.male": "Úr",
	"field.salutation.female": "Hölgy",
	"field.firstName.label": "Utónév",
	"field.lastName.label": "Vezetéknév",
	"field.email.label": "E-mail",
	"field.phone.label": "Telefonszám",
	"button.submit": "Küldés",
	"button.cancel": "Megszakítás",
	"button.back": "vissza",
	"button.next": "tovább",
	"button.close": "Bezárás",
	"button.ok": "Ok",
	"auth.error": "Váratlan hiba történt.",
	"select.placeholder": "Kérjük, válasszon...",
	"validation.requiredField": "A mező kitöltése kötelező",
	"validation.invalidEmail": "Kérjük, adjon meg egy érvényes e-mail címet",
	"validation.maxAllowedCharacters": "Megengedett maximális karakterszám: {{number}}",
	"validation.requiredFieldsExplanation": "A kötelező mezők *-gal vannak jelölve.",
	"validation.invalidPhoneNumber": "Kérjük, írjon be egy érvényes telefonszámot.",
	"softwareProblemClassification.standstill": "Állásidő",
	"softwareProblemClassification.fault": "Hiba",
	"softwareProblemClassification.slightImpairment": "Enyhe károsodás",
	"softwareProblemClassification.generalInquiry": "Általános igény",
	"serviceCase.proactiveCaseClosure.title": "Visszajelzés & esetlezárás igénylése",
	"serviceCase.proactiveCaseClosure.instructions": "Az esetlezárás igényléséhez és ahhoz, hogy segítse a Predictive Service tökéletesítését, kérjük szépen visszajelzését.",
	"serviceCase.proactiveCaseClosure.question.submit": "Küldés",
	"serviceCase.proactiveCaseClosure.dialogTitle": "Eset lezárása igényelve. Köszönjük a visszajelzését.",
	"serviceCase.proactiveCaseClosure.dialog.buttonOk": "Ok",
	"serviceCase.proactiveCaseClosure.question.anomaly": "A jelzett anomália fennállt az Ön gépén?",
	"serviceCase.proactiveCaseClosure.question.technicalGuideLinked": "Rendelkezésre bocsátottak egy műszaki útmutatót?",
	"serviceCase.proactiveCaseClosure.question.technicalGuideHelpful": "Meg tudta oldani önállóan a problémát a műszaki útmutató(k) segítségével?",
	"serviceCase.proactiveCaseClosure.question.pauseRequest": "Szüneteltetni szeretné az értesítéseket az ilyen típusú anomáliák esetén?",
	"serviceCase.proactiveCaseClosure.question.pauseRequestDuration": "Mennyi időre szeretné szüneteltetni az értesítéseket az ilyen típusú anomáliák esetén?",
	"serviceCase.proactiveCaseClosure.question.comment": "Kérjük, magyarázza meg, miért szeretné szüneteltetni az értesítéseket az ilyen típusú anomáliák esetén:",
	"serviceCase.proactiveCaseClosure.question.commentPlaceholder": "A magyarázat kötelező az esetlezárás igényléséhez és a visszajelzés elküldéséhez",
	"serviceCase.proactiveCaseClosure.answers.yes": "Igen",
	"serviceCase.proactiveCaseClosure.answers.no": "Nem",
	"serviceCase.proactiveCaseClosure.answers.sevenDays": "7 nap",
	"serviceCase.proactiveCaseClosure.answers.fourteenDays": "14 nap",
	"serviceCase.proactiveCaseClosure.answers.thirtyDays": "30 nap",
	"serviceCase.proactiveCaseClosure.answers.ninetyDays": "90 nap",
	"sisConnector.success.headline": "Szervizeset sikeresen létrehozva.",
	"sisConnector.success.orderNumberRequired.title": "Fontos tudnivaló:",
	"sisConnector.success.orderNumberRequired.text": "Kérjük, az eset részletes oldalán adjon meg egy rendelési számot az eset elszámolásához és további szolgáltatásokhoz.",
	"sisConnector.success.technicalGuide.title": "E(zek)hez a hibaszám(ok)hoz műszaki útmutató áll rendelkezésre.",
	"sisConnector.success.technicalGuide.text": "A megadott hibaszám(ok) alapján egy vagy több műszaki útmutatót lehetett meghatározni. Ön most már az esetek kb. 50%-ban képes önállóan megoldani problémáját. Ez a funkció csak megfelelő szervizszerződés esetén áll rendelkezésre.",
	"sisConnector.success.outsideOfServiceHours": "Felhívjuk figyelmét, hogy a szolgálati időn kívül létrehozott esetek nem kerülnek feldolgozásra.",
	"sisConnector.success.serviceTimes.MonFri": "Szolgálati időnk a következő: hétfőtől péntekig",
	"sisConnector.success.serviceTimes.Sat": "és szombaton",
	"sisConnector.success.withTechnicalServiceHotline": "Ha azonnali segítségre van szüksége, a TRUMPF műszaki szolgálatát ({{hotline}}) hívhatja támogatás céljából.",
	"sisConnector.success.withoutTechnicalServiceHotline": "Ha azonnali segítségre van szüksége, a TRUMPF műszaki szolgálatát hívhatja támogatás céljából.",
	"sisConnector.success.caseId": "Esetszám",
	"sisConnector.failed.headline": "A szervizesetet nem lehetett létrehozni.",
	"sisConnector.failed.unknownError": "Kérjük, próbálja meg újra, vagy forduljon ügyfélszolgálatunkhoz."
};
var huHU = {
	locale: locale,
	translations: translations
};

export { huHU as default, locale, translations };
//# sourceMappingURL=hu-HU-kcp2rx4g.js.map

//# sourceMappingURL=hu-HU-kcp2rx4g.js.map